import { CITY, COUNTRY } from '../actions/country';

const initialState = {
  Countries: [],
  CountriesList: [],
  cities: [],
  citiesMap: new Map(),
  countriesCodes: new Map(),
  countriesMap: new Map(),
  countriesCodesMap: new Map(),
  countriesDialCodes: new Map(),
  Countryloaded: false,
  Countryloading: false,
  Citiesloaded: false,
  Citiesloading: false,
};

export default (state = initialState, { type, ...action }) => {
  switch (type) {
    case COUNTRY.LOAD:
      return Object.assign({}, state, { Countryloaded: false }, { Countryloading: true });
    case COUNTRY.LOAD_DONE: {
      const countriesMap = new Map();
      action.countries.forEach(country => countriesMap.set(country.CountryId, country));
      const countries  = action.countries.map(country => { 
        const NameEnglish = country.LanguageItemModels.find(model => model.LanguageId === 1).Name;
        const NameArabic = country.LanguageItemModels.find(model => model.LanguageId === 2).Name;
        return { ...country , NameArabic, NameEnglish}
      })
      return {
        ...state,
        Countries: countries,
        countriesMap,
        Countryloaded: true,
        Countryloading: false,
      };
    }
    case COUNTRY.LOAD_FAIL:
      return {
        ...state,
        Countryloaded: false,
        Countryloading: false,
      };
    case COUNTRY.LOAD_LIST:
      return {
        ...state,
        Countryloaded: false,
        Countryloading: true,
      };
    case COUNTRY.LOAD_LIST_DONE: {
      const countriesCodes = new Map();
      const countriesCodesMap = new Map();
      const countriesDialCodes = new Map();

      action.countries.forEach(country => {
        countriesCodes.set(country.IsoCode, country.DialCode);
        countriesCodesMap.set(country.IsoCode, country);
        countriesDialCodes.set(country.DialCode, country.IsoCode);
      });

      return {
        ...state,
        CountriesList: [...action.countries],
        countriesCodes,
        countriesCodesMap,
        countriesDialCodes,
        Countryloaded: true,
        Countryloading: false,
      };
    }
    case COUNTRY.LOAD_LIST_FAIL:
      return {
        ...state,
        Countryloaded: false,
        Countryloading: false,
      };
    case CITY.LOAD:
      return {
        ...state,
        Citiesloaded: false,
        Citiesloading: true,

      }
    case CITY.LOAD_DONE:{
      const citiesMap = new Map();
      action.cities.forEach(city => citiesMap.set(
        city.CityLanguageItemModels[0].Url.slice(0,city.CityLanguageItemModels[0].Url.indexOf(',')), city));
      const cities = action.cities.map(city => {
        const NameEnglish = city.CityLanguageItemModels.find(model => model.LanguageId === 1).Name;
        const NameArabic = city.CityLanguageItemModels.find(model => model.LanguageId === 2).Name;
        return { ...city, NameArabic, NameEnglish}
      })
      return {
        ...state,
        cities,
        citiesMap,
        Citiesloaded: true,
        Citiesloading: false,
      }
    }
    case CITY.LOAD_FAIL:
      return {
        ...state,
        Citiesloaded: false,
        Citiesloading: false,
      }
    default:
      return state;
  }
};
